import { useRepeatingTasks as _useRepeatingTasks } from '@griply/hooks';
import { RepeatingTask } from '@griply/types';
import { DeletedFilter, DeletedFilterOption } from '@griply/utils';
import { useTasksQuery } from 'shared/hooks/queries/use-tasks-query';
import { useUser } from 'shared/hooks/use-user';
import { GetTaskOptions } from 'shared/services/backend-api';
import { TaskType } from 'shared/types/task-base';

export type Options = Omit<GetTaskOptions, 'type'> & DeletedFilterOption;

export const useRepeatingTasks = ({
  deletedFilter = DeletedFilter.ExcludeDeleted,
  ...options
}: Options = {}): RepeatingTask[] => {
  const user = useUser();
  const { data } = useTasksQuery(
    user?.uid,
    { ...options, type: TaskType.Repeating },
    true,
    { deletedFilter },
  );
  return _useRepeatingTasks({ tasks: data ?? [] });
};
